<template>
  <div class="modal animated is-active">
    <div class="modal-background"></div>
    <div class="modal-card is-large">
      <header class="modal-card-head">
        <p class="modal-card-title">Add Services to Invoice #{{invoice_id}}</p>
      </header>
      <section class="modal-card-body">
        <div class="notification is-danger" v-if="error !== ''">{{ error }}</div>
        <div class="control is-vertical">
          <div class="control is-grouped">
            <p class="control is-expanded">
              <label class="label">Services</label>
              <textarea class="textarea" name="services" id="services" placeholder="" v-model="services"></textarea>
            </p>
          </div>
        </div>
        <div v-if="result !== null">
          <table class="table is-bordered is-striped is-narrow">
            <tr>
              <th>Service</th>
              <th>Message</th>
            </tr>
            <tr v-for="res in result">
              <td>{{res.service}}</td>
              <td>{{res.description}}</td>
            </tr>
          </table>
        </div>
      </section>
      <footer class="modal-card-foot">
        <div class="control is-grouped is-pulled-right">
          <p class="control is-pulled-right">
            <a class="button is-primary" @click="close(true)">Cancel</a>
          </p>
          <p class="control">
            <a :class="{'button': true, 'is-success': true, 'is-disabled': errors.any() || inProgress, 'is-loading': inProgress}" @click="add()">Add</a>
          </p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      context: {
        type: Object
      },
      invoice_id: {
        type: Number,
        required: true
      },
      callback: {
        type: String
      }
    },
    data () {
      return {
        services: '',
        inProgress: false,
        error: '',
        result: null
      }
    },
    mounted () {
      this.$nextTick(() => {
        document.body.appendChild(this.$el)
      })
    },
    methods: {
      close (closeOnly, result) {
        if (!closeOnly) {
          this.context[this.callback](result)
        }
        this.$el.remove()
      },
      add () {
        this.inProgress = true
        if (window.confirm('Are you sure you want add services?')) {
          this.error = ''
          this.context.$http.post(this.context.$store.state.config.apiURL + '/invoice/add/services', {invoice_id: this.invoice_id, services: this.services}).then((response) => {
            if (response.body.hasOwnProperty('error')) {
              this.error = response.body.message
            } else {
              console.log(response.body)
              this.result = response.body
            }
            this.inProgress = false
          }, (response) => {
            this.inProgress = false
            this.error = response.body
          })
        } else {
          this.inProgress = false
        }
      }
    },
    components: {
    },
    computed: {
      enterClass () {
        return `${this.transition}In`
      },
      leaveClass () {
        return `${this.transition}Out`
      }
    }
  }
</script>
<style lang="scss">

</style>



// WEBPACK FOOTER //
// AddServicesInvoice.vue?94b55aa4